import { render, staticRenderFns } from "./Speaking2.vue?vue&type=template&id=1a3e0d66&scoped=true"
import script from "./Speaking2.vue?vue&type=script&lang=js"
export * from "./Speaking2.vue?vue&type=script&lang=js"
import style0 from "./Speaking2.vue?vue&type=style&index=0&id=1a3e0d66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3e0d66",
  null
  
)

export default component.exports